export default __webpack_public_path__ + "static/media/ryan-headshot-2022.a7eaad32.png";